import { API_ROUTES } from '@/constants/apiRoutes';
import { AxiosInstance } from 'axios';

export interface CreatePlanPayload {
  planTitle: string;
  planTitleEng: string;
  planId: string;
  description?: string;
  planType: string;
  planCategory: string;
  planTime: string;
  planPrice: string;
  strikePrice: string;
  isStrikeOut: string;
  liquor: string;
  nomination: number;
  noOfPeople?: number;
}

export interface TogglePlanStatusPayload {
  planId: string;
  status: 'D';
}

const createPlan = (client: AxiosInstance) => async (payload: CreatePlanPayload) => {
  return (
    await client.post<{ message: string; data: CreatePlanPayload }>('/manage-plan', {
      ...payload,
    })
  ).data;
};

const updatePlanStatus = (client: AxiosInstance) => async (payload: { planId: string; status: 'A' | 'B' | 'D' }) => {
  return (
    await client.post<{ message: string; data: { planId: string; status: string } }>(API_ROUTES.UPDATE_PLAN_STATUS, {
      ...payload,
    })
  ).data;
};

export const hoslogPlansMutations = {
  createPlan,
  updatePlanStatus,
};
